import { TitleCasePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'humancase' })
export class HumanCasePipe {
    transform(value: string): string {
        let parsed = '';
        // CamelCase
        for (let c of value) {
            if (
                parsed.length &&
                /[a-z]/.test(parsed[parsed.length - 1]) &&
                /[A-Z]/.test(c)
            ) {
                parsed += '+';
            }

            parsed += c;
        }

        // typical delimiter
        parsed = parsed.replace(/[\_\-\+]/g, ' ');

        // title case
        parsed = new TitleCasePipe().transform(parsed);
        return parsed;
    }
}
